import raw from "../../data/tables/art/packs/frontline/grips.json";
import type { GripPack } from "./grip-resolve";

/** Frontline T2/T3 grip SSOT. */
export const frontlineGripPack = raw as unknown as GripPack;
